import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const pulse = keyframes`
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
`;

export const Container = styled.div`
  min-height: 100vh;
  min-width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
`;

export const Content = styled.div`
  max-width: 600px;
  width: 100%;
  background: white;
  border-radius: 20px;
  padding: 60px 40px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: ${fadeIn} 0.6s ease-out;
  text-align: center;
`;

export const Title = styled.h1`
  font-size: 28px;
  font-weight: 700;
  color: #2d3748;
  margin-bottom: 40px;
  line-height: 1.4;
`;

export const ProgressContainer = styled.div`
  margin-bottom: 30px;
`;

export const ProgressBar = styled.div`
  width: 100%;
  height: 24px;
  background-color: #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
  position: relative;
  margin-bottom: 12px;
`;

export const ProgressFill = styled.div<{ progress: number }>`
  height: 100%;
  width: ${(props) => props.progress}%;
  background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px;
  transition: width 0.3s ease-out;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.3),
      transparent
    );
    animation: shimmer 2s infinite;
  }

  @keyframes shimmer {
    0% {
      transform: translateX(-100%);
    }
    100% {
      transform: translateX(100%);
    }
  }
`;

export const ProgressText = styled.div`
  font-size: 20px;
  font-weight: 600;
  color: #667eea;
`;

export const StatusText = styled.div`
  font-size: 18px;
  color: #4a5568;
  margin-bottom: 20px;
  font-weight: 500;
  animation: ${pulse} 2s ease-in-out infinite;
`;

export const StepIndicator = styled.div`
  margin-bottom: 30px;
`;

export const StepText = styled.div`
  font-size: 16px;
  color: #718096;
  font-weight: 500;
`;

export const InfoText = styled.div`
  font-size: 14px;
  color: #a0aec0;
  line-height: 1.8;
  margin-top: 20px;
  margin-bottom: 30px;
`;

export const CancelButton = styled.button`
  padding: 12px 32px;
  font-size: 16px;
  font-weight: 500;
  color: #718096;
  background: transparent;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #f7fafc;
    border-color: #cbd5e0;
    color: #4a5568;
  }

  &:active {
    transform: scale(0.98);
  }
`;
